import React from "react";

const PageBanner = ({ title, subtitle, image }) => {
  return (
    <div className="relative gpm-bg-green overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt={title} className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 gpm-bg-green opacity-70" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-6 py-20 md:py-24 text-center">
        <h1 className="font-serif-display text-4xl md:text-5xl font-bold gpm-text-cream">{title}</h1>
        <div className="gpm-divider mx-auto my-5" />
        {subtitle && <p className="gpm-text-cream opacity-80 max-w-2xl mx-auto text-sm md:text-base">{subtitle}</p>}
      </div>
    </div>
  );
};

export default PageBanner;
